export default __webpack_public_path__ + "static/media/tooltip2D-complex.9b21f3ac.png";